import { useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { Globe2 } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common";
import { api } from "@/lib/api";
import { Contacts } from "@/components/netsoci/Contacts";
import { SearchAdmins } from "@/components/netsoci/SearchAdmins";
import { ConnRequests } from "@/components/netsoci/ConnRequests";
import { Convocations } from "@/components/netsoci/Convocations";
import { MyCode } from "@/components/netsoci/MyCode";

export default function NetworkSoci() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "contatti";
  const [conns, setConns] = useState(null);
  const [unread, setUnread] = useState({});
  const load = useCallback(() => {
    api.get("/network/connections").then((r) => setConns(r.data));
    api.get("/network/unread").then((r) => setUnread(r.data));
  }, []);
  useEffect(() => { load(); }, [load]);
  const go = (t) => setParams(t === "contatti" ? {} : { tab: t });
  const badge = (n) => (n > 0 ? ` (${n})` : "");
  return (
    <div data-testid="network-soci-page">
      <PageHeader title="Network Soci" subtitle="Collegati e collabora con gli amministratori di altre aziende. Le reti aziendali restano separate e private." />
      <div className="mb-5 flex items-start gap-2 rounded-md border border-primary/30 bg-primary/5 px-4 py-3 text-xs text-muted-foreground">
        <Globe2 className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
        <span>Gli amministratori collegati vedono solo nome, ruolo e società. Nessun collegamento dà accesso a dipendenti, richieste, documenti o comunicazioni della tua azienda.</span>
      </div>
      <MyCode onChange={load} />
      <Tabs value={tab} onValueChange={go} className="mb-5">
        <TabsList className="flex-wrap">
          <TabsTrigger value="contatti" data-testid="netsoci-tab-contacts">Collegamenti{badge(unread.messages)}</TabsTrigger>
          <TabsTrigger value="cerca" data-testid="netsoci-tab-search">Cerca soci</TabsTrigger>
          <TabsTrigger value="richieste" data-testid="netsoci-tab-requests">Richieste{badge(unread.requests)}</TabsTrigger>
          <TabsTrigger value="convocazioni" data-testid="netsoci-tab-convocations">Convocazioni{badge(unread.convocations)}</TabsTrigger>
        </TabsList>
      </Tabs>
      {conns && tab === "contatti" && <Contacts conns={conns} onChange={load} initialChat={params.get("chat")} />}
      {tab === "cerca" && <SearchAdmins onChange={load} />}
      {conns && tab === "richieste" && <ConnRequests conns={conns} onChange={load} />}
      {conns && tab === "convocazioni" && <Convocations contacts={conns.accepted} onChange={load} />}
    </div>
  );
}
